import React from 'react';
import { Result } from 'antd';
import { Button } from '@bluevision/components';
import { Link } from 'umi';
import { useTranslation } from 'react-i18next';

const NoAccess: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Result
      status={403}
      title={t('no_page_access_permissions')}
      subTitle={t('sorry_no_permission_contact_admin')}
      extra={
        <Button type='default'>
          <Link to='/user/login'>{t('return_to_login_page')}</Link>
        </Button>
      }
    />
  );
};
export default NoAccess;
